import { v4 } from 'uuid';

import type { Distributor } from '@energy-retailer/schema';

export type DistributorsQueryKey = [string, { postcode: string }];

type DistributorError = {
  error: string;
};

export type DistributorResponse = {
  items?: Distributor[];
  error?: string;
};

export const getDistributors = async ({
  queryKey,
}): Promise<DistributorResponse | undefined> => {
  const [_key, params] = queryKey as DistributorsQueryKey;

  const { postcode } = params;

  if (postcode.length < 4) {
    return { items: [] };
  }

  try {
    const response: Response = await window.AwsWafIntegration.fetch(
      `${process.env.NEXT_PUBLIC_API_URL}/distributors?postcode=${postcode}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'x-correlation-id': v4(),
          'x-session-id': window.sessionStorage.getItem('sessionId') ?? '',
        },
      }
    );

    if (response.ok) {
      const data = (await response.json()) as Distributor[];
      return { items: data };
    }

    if (response.status === 404) {
      const data = (await response.json()) as DistributorError;
      return { error: data.error };
    }
  } catch (error) {
    throw new Error('Unexpected error');
  }
};
